import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import axios from 'axios'
import { API_VERSION, API_SETTING_URL } from '@/.env'

export default class StoreService extends BaseService {
  static get entity () {
    return 'stores'
  }

  static async getStoreByUser (customerId) {
    try {
      const response = await axios.get(`${API_SETTING_URL}/${API_VERSION}/stores`, { params: { customerId: customerId } })
      if (response.data.items) {
        const data = response.data.items
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }

  static async getCurrenStoreByUser (customerId) {
    try {
      const response = await axios.get(`${API_SETTING_URL}/${API_VERSION}/stores`, { params: { customerId: customerId } })
      if (response.data.items) {
        const data = response.data.items
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }

  static async getStoreConfig (storeId, viewId) {
    try {
      const response = await axios.get(`${API_SETTING_URL}/${API_VERSION}/stores/${storeId}/shop`, { params: { viewId: viewId } })
      if (response.data) {
        const data = response.data
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }

  static async getTaxConfigs (storeId) {
    try {
      const response = await axios.get(`${API_SETTING_URL}/${API_VERSION}/stores/${storeId}/tax-configs`, { params: { page: 1, limit: 100 } })
      if (response.data) {
        const data = response.data
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }

  static async getViews (storeId) {
    try {
      const response = await axios.get(`${API_SETTING_URL}/${API_VERSION}/stores/${storeId}/views`, { params: { page: 1, limit: 100 } })
      if (response.data) {
        const data = response.data
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }
}
